export const statusOptions = [
    { text: 'monitoring.all', value: -1 },
    { text: 'monitoring.success', value: 1 },
    { text: 'monitoring.error', value: 0 }
];
